import Vue from 'vue';
import Router from 'vue-router';
import LoginPage from '../views/Login.vue';
import HomePage from '../views/Home.vue';
import SimulaPage from '../views/ProgramaTrabajos/SimularTrabajos.vue';
import GeneraPage from '../views/ProgramaTrabajos/GenerarPrograma.vue';
import EvaluarPage from '../views/ProgramaTrabajos/EvaluarAvance.vue';
import CumplimientoPage from '../views/ProgramaTrabajos/CumplimientoProveedore.vue';
import ValidarPage from '../views/ValidarODMs.vue';
import EstadoMaterialesPage from '../views/EstadoMateriales.vue';
import AvisosPage from '../views/Avisos.vue';
import CostosPage from '../views/Costos.vue';
import AnalisisAceite from '../views/AnalisisAceite.vue';
import Test from '../views/ProgramaTrabajos/TestGenera.vue';
import Files from '../views/ProgramaTrabajos/Files.vue';

import CentroEmplazamiento from '../views/Administracion/CentroEmplazamientos.vue';
import Responsables from '../views/Administracion/Responsables.vue';
import Embarcaciones from '../views/Administracion/Embarcaciones.vue';

import PruebaMuestreo from '../views/MuestreoAceite.vue';
import ControlEngrase from '../views/Engrase/ControlEngrase.vue';
import HistoricoEngrase from '../views/Engrase/HistoricoEngrase.vue';
import Medidores from '@/views/Medidores.vue';

Vue.use(Router);
let inactivityTimer
const inactivityTimeout = 30 * 60 * 1000 // 10 minutos en milisegundos

function resetInactivityTimer() {
  if (inactivityTimer) {
    clearTimeout(inactivityTimer);
  }
  inactivityTimer = setTimeout(() => {
    if (router.currentRoute.path !== '/') {
      router.push('/'); // Utiliza router.replace en lugar de router.push
    }
  }, inactivityTimeout);
}

// Escucha los eventos de interacción del usuario
document.addEventListener('mousemove', resetInactivityTimer)
document.addEventListener('keydown', resetInactivityTimer)

const routes = [
  {
    path: '/',
    name: 'Login',
    component: LoginPage,
    meta: { title: 'Inicio de Sesión' },
  },
  {
    path: '/home',
    name: 'Home',
    component: HomePage,
    meta: { title: 'Inicio' },
  },
  {
    path: '/simularProg',
    name: 'Simular Programa de Trabajos',
    component: SimulaPage,
    meta: { title: 'Simular Programa de Trabajos' },
  },
  {
    path: '/generarProg',
    name: 'Generar Programa de Trabajos',
    component: GeneraPage,
    meta: { title: 'Generar Programa de Trabajos' },
  },
  {
    path: '/evaluarAvance',
    name: 'Evaluar Avance de Trabajos',
    component: EvaluarPage,
    meta: { title: 'Evaluar Avance de Trabajos' },
  },
  {
    path: '/cumplimientoProveedores',
    name: 'Cumplimiento Proveedores',
    component: CumplimientoPage,
    meta: { title: 'Cumplimiento de Proveedores' },
  },
  {
    path: '/validarOdms',
    name: 'Validar ODMs',
    component: ValidarPage,
    meta: { title: 'Validar ODMs' },
  },
  {
    path: '/estadoMateriales',
    name: 'Estado Materiales',
    component: EstadoMaterialesPage,
    meta: { title: 'Estado de Materiales' },
  },
  {
    path: '/avisos',
    name: 'Avisos',
    component: AvisosPage,
    meta: { title: 'Avisos' },
  },
  {
    path: '/costos',
    name: 'Costos',
    component: CostosPage,
    meta: { title: 'Presupuestos' },
  },
  {
    path: '/analisisAceite',
    name: 'Análisis Aceite',
    component: AnalisisAceite,
    meta: { title: 'Análisis de Aceite' },
  },
  {
    path: '/test',
    name: 'Test',
    component: Test,
    meta: { title: 'Generar Programa de Trabajos' },
  },
  {
    path: '/filesProgramaTrabajos',
    name: 'Files',
    component: Files,
    meta: { title: 'Documentos Programa de Trabajos' },
  },
  {
    path: '/centroEmplazamientos',
    name: 'Centros de Emplazamiento',
    component: CentroEmplazamiento,
    meta: { title: 'Centros de Emplazamiento' },
  },
  {
    path: '/responsables',
    name: 'Responsable Embarcaciones',
    component: Responsables,
    meta: { title: 'Responsable Embarcaciones' },
  },
  {
    path: '/embarcaciones',
    name: 'Embarcaciones',
    component: Embarcaciones,
    meta: { title: 'Embarcaciones' },
  },
  {
    path: '/muestreoAceite',
    name: 'Programa de Muestreo de Aceite',
    component: PruebaMuestreo,
    meta: { title: 'Programa de Muestreo de Aceite' },
  },
  {
    path: '/historicoEngrase',
    name: 'Historico Engrase',
    component: HistoricoEngrase,
    meta: { title: 'Historico de Engrase' },
  },
  {
    path: '/registroCheck',
    name: 'Registro Checklist',
    component: ControlEngrase,
    meta: { title: 'Registro de Checklist Engrase' },
  },

    {
    path: '/medidores',
    name: 'Medidores',
    component: Medidores,
    meta: { title: 'Medidores' },
  },
];

const router = new Router({
  mode: 'history', // Usa el historial del navegador
  base: process.env.BASE_URL,
  created() {
    resetInactivityTimer()
  },
  routes,
});

// Verificación de autenticación antes de cada ruta
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token');
  if (to.name !== 'Login' && !token) {
    next({ name: 'Login' });
  } else {
    next();
  }
});

export default router;
